
















































































































































































































































































import {
  ExpandedFacilityStatisticsPayload,
  ExpandedUnitStatisticsPayload,
  PriceChange,
  PriceChangePayload,
  PriceOptimizerState,
  PriceOptimizerUnit,
  PriceOptimizerTableItem
} from "@/models";
import PriceOptimizerModule from "@/store/modules/price-optimizer";
import { formatDate } from "@/helpers/functions/format-date";
import UnitQuickstats from "@/views/price-optimizer/components/UnitQuickstats.vue";
import { AxiosResponse } from "axios";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import QueueDisplay from "@/views/price-optimizer/components/QueueDisplay.vue";
import ApplicationModal from "@/components/global/ApplicationModal.vue";
import DateRangeStatistics from "@/views/price-optimizer/components/DateRangeStatistics.vue";
import { priceOptimizerHeaders } from "@/helpers/price-optimizer/price-optimizer-headers";
import { DataTableItemProps } from "vuetify";

const priceOptimizer = namespace(PriceOptimizerModule.name);

@Component({
  name: "UnitTypesTable",
  components: {
    ApplicationModal,
    DateRangeStatistics,
    QueueDisplay,
    UnitQuickstats
  }
})
export default class UnitTypesTable extends Vue {
  // ===== Store ===== //
  @State("priceOptimizer") private readonly priceOptimizer!: PriceOptimizerState;
  @priceOptimizer.Action private applyFilters!: () => void;
  @priceOptimizer.Action private commitActiveUnitTypePanelTab!: (activeUnitTypePanelTab: number) => void;
  @priceOptimizer.Action private commitFacilityUnitTypeId!: (facilityUnitTypeId: number) => void;
  @priceOptimizer.Action private commitShowRefreshButton!: (status: boolean) => void;
  @priceOptimizer.Action private createPriceChange!: (payload: PriceChangePayload) => AxiosResponse;
  @priceOptimizer.Action private getExpandedFacilityStatistics!: (payload: ExpandedFacilityStatisticsPayload) => void;
  @priceOptimizer.Action private getExpandedUnitStatistics!: (payload: ExpandedUnitStatisticsPayload) => void;
  @priceOptimizer.Action private updatePriceChange!: (payload: PriceChangePayload) => AxiosResponse;
  @priceOptimizer.Getter private rateQueueUnits!: PriceOptimizerUnit[];
  @priceOptimizer.Mutation private setFacilityId!: (facilityId: number) => void;

  // ===== Props ===== //
  @Prop(String) private readonly tableType!: string;

  // ===== Data ===== //
  private expanded: PriceOptimizerUnit[] = [];
  private startingNewRate = "";
  private selectedUnitIndex = 0;
  private headers = priceOptimizerHeaders;

  // ===== Methods ===== //
  private customSort(items: PriceOptimizerTableItem[], indexList: string[], isDesc: boolean[]): PriceOptimizerTableItem[] {
    items.sort((a: PriceOptimizerTableItem, b: PriceOptimizerTableItem): number => {
      const index = indexList[0] as keyof PriceOptimizerTableItem;
      if (index === "ins_outs") {
        // only sort by net for in/out/net
        if (isDesc[0]) {
          return b.net_move_ins - a.net_move_ins;
        } else {
          return a.net_move_ins - b.net_move_ins;
        }
      }
      if (index === "width") {
        // area of <a> vs area of <b> - default to 1 if either is zero.
        if (isDesc[0]) {
          return (a.width || 1) * (a.length || 1) < (b.width || 1) * (b.length || 1) ? 1 : -1;
        } else {
          return (a.width || 1) * (a.length || 1) < (b.width || 1) * (b.length || 1) ? -1 : 1;
        }
      } else if (typeof a[index] === "string" && typeof b[index] === "string") {
        // default string sort
        if (a[index] === b[index]) {
          return 0;
        } else if (isDesc[0]) {
          return a[index]! < b[index]! ? 1 : -1;
        } else {
          return a[index] === null || b[index]! < a[index]! ? -1 : 1;
        }
      } else {
        // default sort
        if (a[index] === b[index]) {
          return 0;
        } else if (isDesc[0]) {
          return b[index] as number - (a[index] as number);
        } else {
          return a[index] as number - (b[index] as number);
        }
      }
    });
    return items;
  }
  public formatDate = formatDate;
  private handleDblClick(event: Event, row: DataTableItemProps): void {
    if (
      this.expanded &&
      this.expanded[0] &&
      this.expanded[0].id === row.item.id
    ) {
      this.expanded = [];
      return;
    }
    this.expanded = [row.item];
    this.handleExpandedStats(row.item);
  }
  private handleExpandedStats(unit: PriceOptimizerUnit): void {
    const expandedFacilityStatisticsPayload: ExpandedFacilityStatisticsPayload = {
      start_date: moment.utc().subtract("30", "days").format(),
      end_date: moment.utc().format(),
      facility_id: unit.facilityId
    };
    const expandedUnitStatisticsPayload: ExpandedUnitStatisticsPayload = {
      start_date: moment.utc().subtract("30", "days").format(),
      end_date: moment.utc().format(),
      unit_type_id: unit.facility_unit_type_id
    };
    this.selectedUnitIndex = unit.id;
    this.setFacilityId(unit.facilityId);
    this.commitFacilityUnitTypeId(unit.facility_unit_type_id);
    this.commitActiveUnitTypePanelTab(0);
    this.getExpandedFacilityStatistics(expandedFacilityStatisticsPayload);
    this.getExpandedUnitStatistics(expandedUnitStatisticsPayload);
  }

  private queuedStatus(data: PriceChange): string | null {
    let result = null;
    if (data && data.price_change_set && data.price_change_set.status && data.price_change_set.status.name) {
      result = data.price_change_set.status.name;
    }
    return result;
  }

  private formatCurrency(value: number): string {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return formatter.format(value);
  }

  private handleInputKeyDown(event: KeyboardEvent): void {
    if (!event || !event.target) {
      return;
    }
    const typedTarget = event.target as HTMLInputElement;
    if (typedTarget.value === "0") {
      typedTarget.value = "";
    }
  }
  private refreshUnitTypesTable() {
    this.applyFilters();
    this.commitShowRefreshButton(false);
  }
  private async submitRateChange(unit: PriceOptimizerUnit): Promise<void> {
    if (!unit) {
      return;
    }
    let response;
    const payload: PriceChangePayload = {
      new_price: unit.new_rate,
      facility_unit_type_id: unit.facility_unit_type_id,
      price_change_id: unit.price_change_data ? unit.price_change_data.id : undefined
    };
    try {
      response = this.queuedStatus(unit.price_change_data)
        ? await this.updatePriceChange(payload)
        : await this.createPriceChange(payload);
      unit.price_change_data = response.data;
      /* istanbul ignore next */
      unit.new_rate = response.data.new_price.toFixed(0);
    } catch (error) {
      unit.new_rate = parseFloat(this.startingNewRate);
    }
    unit.rate_change_active = false;
  }

  private selectItem(unit: PriceOptimizerUnit): void {
    if (unit.locked) {
      return;
    }
    /* istanbul ignore next */
    if (!this.activeRateChange) {
      this.startingNewRate = unit.new_rate.toString();
      unit.rate_change_active = true;
    }
  }
  private unselectItem(unit: PriceOptimizerUnit): void {
    unit.new_rate = parseFloat(this.startingNewRate);
    unit.rate_change_active = false;
  }
  // ===== Computed ===== //
  get units(): PriceOptimizerUnit[] {
    /* istanbul ignore next */
    return this.priceOptimizer.units;
  }
  get activeRateChange(): boolean {
    /* istanbul ignore next */
    return this.units.some((unit) => unit.rate_change_active);
  }
  get dataTable(): PriceOptimizerUnit[] {
    /* istanbul ignore next */
    if (this.tableType === "filteredPO") {
      return this.priceOptimizer.filteredUnits;
    } else {
      return this.units;
    }
  }
  /* istanbul ignore next */
  get noDataText(): string {
    if (this.tableType === "filteredPO") {
      return this.priceOptimizer.loadingState.length ? "Retrieving filtered units..." : "No filtered units found";
    }
    return this.priceOptimizer.loadingState.includes("units loading") ? "Retrieving units..." : "No units found";
  }
  get expandedStatisticsLoading(): boolean {
    const evalLoading = (type: string) => this.priceOptimizer.loadingState
      .includes(`getting expanded ${type} statistics`);

    return evalLoading("unit") || evalLoading("facility");
  };
};
